var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _path, _rect33, _rect34, _rect35, _rect36;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortingGuide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9062,
    y: 37.832,
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    fill: "#145DB6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    transform: "matrix(-1 0 0 1 78.0273 50)",
    fill: "#145DB6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    transform: "matrix(-1 0 0 1 78.0273 43.1641)",
    fill: "#145DB6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    transform: "matrix(-1 0 0 1 78.0273 57.3828)",
    fill: "#145DB6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    transform: "matrix(-1 0 0 1 78.0273 64.4922)",
    fill: "#145DB6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    transform: "matrix(0 1 1 0 69.5508 69.4141)",
    fill: "#145DB6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2461,
    y: 50,
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    fill: "#145DB6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2461,
    y: 43.1641,
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    fill: "#145DB6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9062,
    y: 45.2148,
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    fill: "#145DB6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 48.7695,
    y: 37.9688,
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    fill: "#145DB6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1145,
    y: 36.0503,
    width: 2.32422,
    height: 15.0391,
    rx: 1.16211,
    transform: "rotate(-117.561 31.1145 36.0503)",
    fill: "#145DB6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 2.32422,
    height: 15.0391,
    rx: 1.16211,
    transform: "matrix(0.462688 -0.886521 -0.886521 -0.462688 68.6644 35.7769)",
    fill: "#145DB6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2461,
    y: 57.3828,
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    fill: "#145DB6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2461,
    y: 64.4922,
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    fill: "#145DB6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7227,
    y: 69.4141,
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    transform: "rotate(90 30.7227 69.4141)",
    fill: "#145DB6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7227,
    y: 69.4141,
    width: 2.32422,
    height: 4.78516,
    rx: 1.16211,
    transform: "rotate(90 30.7227 69.4141)",
    fill: "#145DB6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19.9219,
    width: 16.9531,
    height: 24.0625,
    rx: 3,
    fill: "#F0C419"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6914,
    y: 22.793,
    width: 9.70703,
    height: 2.46094,
    rx: 1.23047,
    fill: "#F3D55B"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6914,
    y: 27.5781,
    width: 9.70703,
    height: 2.46094,
    rx: 1.23047,
    fill: "#F3D55B"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6914,
    y: 32.6367,
    width: 9.70703,
    height: 2.46094,
    rx: 1.23047,
    fill: "#F3D55B"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6914,
    y: 37.832,
    width: 9.70703,
    height: 2.46094,
    rx: 1.23047,
    fill: "#F3D55B"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3867,
    y: 15,
    width: 16.9531,
    height: 24.0625,
    rx: 3,
    fill: "#3B97D3"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 45.0781,
    y: 17.8711,
    width: 9.70703,
    height: 2.46094,
    rx: 1.23047,
    fill: "#90BAE1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 45.0781,
    y: 22.6562,
    width: 9.70703,
    height: 2.46094,
    rx: 1.23047,
    fill: "#90BAE1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 45.0781,
    y: 27.7148,
    width: 9.70703,
    height: 2.46094,
    rx: 1.23047,
    fill: "#90BAE1"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 45.0781,
    y: 32.9102,
    width: 9.70703,
    height: 2.46094,
    rx: 1.23047,
    fill: "#90BAE1"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 68.0469,
    y: 19.7852,
    width: 16.9531,
    height: 24.0625,
    rx: 3,
    fill: "#FF5364"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7383,
    y: 22.6562,
    width: 9.70703,
    height: 2.46094,
    rx: 1.23047,
    fill: "#FB7B76"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7383,
    y: 27.4414,
    width: 9.70703,
    height: 2.46094,
    rx: 1.23047,
    fill: "#FB7B76"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7383,
    y: 32.5,
    width: 9.70703,
    height: 2.46094,
    rx: 1.23047,
    fill: "#FB7B76"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7383,
    y: 37.6953,
    width: 9.70703,
    height: 2.46094,
    rx: 1.23047,
    fill: "#FB7B76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.543 49.9368L28.8086 54.0384V82.3392C28.8086 84.1986 30.9505 84.709 32.0215 84.7318H67.5C69.0312 84.1302 69.5508 82.5215 69.6191 81.7923V56.4993C69.6738 54.4212 68.2292 53.7194 67.5 53.6282H49.9316C47.7441 53.6829 47.1517 52.9219 47.1289 52.5345L45.1465 49.9368C44.3809 48.679 43.2324 48.6836 42.7539 48.8431H34.2773C32.418 48.679 31.6797 49.5039 31.543 49.9368Z",
    fill: "#67B9CC"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 33.457,
    y: 57.6562,
    width: 26.25,
    height: 4.78516,
    rx: 2,
    fill: "#41767F"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 33.457,
    y: 68.5938,
    width: 19.2773,
    height: 2.59766,
    rx: 1.29883,
    fill: "#41767F"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 33.457,
    y: 78.1641,
    width: 32.5391,
    height: 2.59766,
    rx: 1.29883,
    fill: "#41767F"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 33.457,
    y: 73.1055,
    width: 10.9375,
    height: 2.59766,
    rx: 1.29883,
    fill: "#41767F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingGuide);
export default __webpack_public_path__ + "static/media/sorting-guide.d745a351cac62792efad6310e49314f0.svg";
export { ForwardRef as ReactComponent };